import React from 'react'

import { Box, Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import SelectField from 'modules/core/components/SelectField'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { validateCodigo } from 'modules/trainings/lib/fundaeUtils'

import { TrainingWizardData } from '../NewTrainingWizard/types'

export function FundaeToggle({
  fundaeSubsidized,
  onChange,
  codigoCurso,
  perfil,
  expediente,
}: {
  fundaeSubsidized: boolean
  onChange(data: Partial<TrainingWizardData>): void
  codigoCurso: string | undefined
  perfil: string | undefined
  expediente: string | undefined
}) {
  const [codigoCursoValid, setCodigoCursoValid] = React.useState(validateCodigo(codigoCurso))
  const options = [
    {
      value: 'Empresa Bonificada',
      label: 'Empresa Bonificada',
    },
    {
      value: 'Organizadora',
      label: 'Organizadora',
    },
    {
      value: 'Grupo de Empresa',
      label: 'Grupo de Empresa',
    },
  ]
  return (
    <Card>
      <Card.Title
        size="small"
        action={
          <TogglerCheckbox
            onChange={(value) => {
              onChange({
                fundaeSubsidized: value,
              })
            }}
            value={fundaeSubsidized}
          />
        }
      >
        {i18n.t('trainings.fundae.toggle.card.title')}
      </Card.Title>
      <Card.Description>{i18n.t('trainings.fundae.toggle.card.description')}</Card.Description>

      <Card.ExpandableContent expanded={fundaeSubsidized}>
        <Box gap="s16">
          <Callout
            description={i18n.t('trainings.fundae.toggle.card.callout.description')}
            type="info"
            title={i18n.t('trainings.fundae.toggle.card.callout.title')}
          />
          <Box gap="s16">
            <TextField
              label={i18n.t('trainings.fundae.toggle.card.course_code_label')}
              value={codigoCurso}
              placeholder="00001"
              onChange={(value: string) => {
                setCodigoCursoValid(validateCodigo(value))
                onChange({ codigoCurso: value })
              }}
              description={i18n.t('trainings.fundae.toggle.card.course_code_description')}
              error={
                codigoCursoValid
                  ? undefined
                  : i18n.t('trainings.fundae.toggle.validation.codigo_curso')
              }
            />
          </Box>

          <SelectField
            label={i18n.t('trainings.fundae.toggle.card.profile_label')}
            description={i18n.t('trainings.fundae.toggle.card.profile_description')}
            value={perfil}
            none={i18n.t('common.select')}
            options={options}
            onChange={(value: string) => onChange({ perfil: value })}
          />
          <TextField
            label={i18n.t('trainings.fundae.toggle.card.file_label')}
            description={i18n.t('trainings.fundae.toggle.card.file_description')}
            value={expediente}
            placeholder="B238888AC"
            onChange={(value: string) => onChange({ expediente: value })}
          />
        </Box>
      </Card.ExpandableContent>
    </Card>
  )
}
